export default "__VITE_ASSET__Ccwmm185__"